import { Component, Vue, VModel, Prop } from 'vue-property-decorator';
import TreeFilter from '@/components/common/tree-filter/TreeFilter.vue';
import { TreeOption } from '@/models';
import { isEqual } from 'lodash';

@Component({
  components: {
    TreeFilter
  }
})
export default class TreeFilterDialog extends Vue {
  @VModel() modalShown!: boolean;
  @Prop({ default: () => [] }) options!: TreeOption[];
  @Prop({ default: 'Export filter by quarter' }) title: string;
  @Prop({ default: false }) isLoading: boolean;

  private selecteds: string[] = [];

  get isDisabled(): boolean {
    return this.isLoading || !this.options?.length;
  }

  get allOptions(): string[] {
    const mappedOptions = this.options.flatMap(option => {
      if (option?.children?.length) {
        return option?.children.map(child => child.id);
      }
      return option.id;
    });
    return mappedOptions.filter(String) as string[];
  }

  onSelectAll(): void {
    this.selecteds = isEqual(this.allOptions, this.selecteds) ? [] : this.allOptions;
  }

  onModalCancel(): void {
    this.$emit('onCancel');
  }

  onModalConfirm(): void {
    this.$emit('onConfirm', this.selecteds);
  }
}
